import { dialogContentSx, centerModalSx, modalStackSx } from 'components/styles/modal';
import { Modal as MuiModal, Box, Stack, IconButton } from 'components/ui';
import { CloseIcon } from 'components/uiIcons';

const Modal = ({ handleClose, children, ...rest }) => {
  return (
    <MuiModal sx={centerModalSx} open={true} onClose={handleClose} {...rest}>
      <Box sx={dialogContentSx}>
        <Stack direction="row" justifyContent="flex-end">
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Stack sx={modalStackSx}>{children}</Stack>
      </Box>
    </MuiModal>
  );
};

export default Modal;
